import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { UTCDateRange } from '@epicuro-next/ataraxia/models';
import {
  firstDayOfWeek,
  firstDayOfWeekUTC,
  lastDayOfWeek,
  lastDayOfWeekUTC,
} from '@epicuro-next/utilities';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
// tslint:disable-next-line:ordered-imports
import { WeeksPresetData } from '../week-number/week-number.component';

@Component({
  selector: 'atx-week-picker',
  templateUrl: './week-picker.component.html',
  styleUrls: ['./week-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WeekPickerComponent implements OnDestroy {
  public minWeekDate: Date | null;
  public maxWeekDate: Date | null;
  private destroy$ = new Subject<void>();
  public selectedDate$ = new Subject();

  @Input() public startDate: Date;
  @Input() public set minDate(date: Date | null) {
    this.minWeekDate = date ? firstDayOfWeek(date) : null;
  }
  @Input() public set maxDate(date: Date | null) {
    this.maxWeekDate = date ? lastDayOfWeek(date) : null;
  }

  @Input()
  public weeksPresetData: WeeksPresetData = {};

  @Output()
  public weekSelect = this.selectedDate$.pipe(
    map((date: string) => {
      return {
        from: firstDayOfWeekUTC(date),
        to: lastDayOfWeekUTC(date),
      } as UTCDateRange;
    }),
    takeUntil(this.destroy$),
  );

  public ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
